import { NeutralButton, NeutralTypeEnum, toast } from '@systemeio/ui'
import { useInterruptSpitTest } from 'modules/newsletters/split-test/hooks/use-interrupt-spit-test'
import React, { useState } from 'react'
import ConfirmationModal from 'shared/components/confirmation-modal'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { BlockedIcon } from '@systemeio/ui/icons'

interface InterruptSplitTestProps {
  opened: boolean
  onClose: () => void
  afterAbandon: () => Promise<void>
  mailingSplitTestId: string | undefined
}

export function InterruptSplitTest({
  opened,
  onClose,
  afterAbandon,
  mailingSplitTestId,
}: InterruptSplitTestProps) {
  const { t } = useLocoTranslation()

  const abandonSpitTest = useInterruptSpitTest(mailingSplitTestId)

  const onConfirm = async () => {
    await abandonSpitTest()
    await afterAbandon()
    toast.success(t('dashboard.newsletter_editor.split_test.interrupt.success'))
  }

  return (
    <ConfirmationModal
      title={t('dashboard.newsletter_editor.split_test.interrupt.title')}
      confirmationText={t('dashboard.newsletter_editor.split_test.interrupt.description')}
      opened={opened}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  )
}

interface InterruptSplitTestWithButtonProps
  extends Omit<InterruptSplitTestProps, 'opened' | 'onClose'> {}

export function InterruptSplitTestWithButton({
  afterAbandon,
  mailingSplitTestId,
}: InterruptSplitTestWithButtonProps) {
  const { t } = useLocoTranslation()
  const [opened, setOpened] = useState(false)

  return (
    <>
      <NeutralButton neutralType={NeutralTypeEnum.danger} onClick={() => setOpened(true)}>
        <BlockedIcon
          className={
            'main-transition-colors group-hover:fill-danger fill-text-primary h-[16px] w-[16px]'
          }
        />
        <span className={'hidden lg:flex'}>
          {t('dashboard.newsletter_editor.split_test.interrupt.title')}
        </span>
      </NeutralButton>
      <InterruptSplitTest
        mailingSplitTestId={mailingSplitTestId}
        opened={opened}
        onClose={() => setOpened(false)}
        afterAbandon={afterAbandon}
      />
    </>
  )
}
